import Vue from "vue";
import Vuex from "vuex";
import http from "./http";
// import da from "element-ui/src/locale/lang/da";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // language: null,
    language: {
      visitor: [],
      home: [],
      staff: [],
      vreserve: [],
      scode: []
    },
    visitor: null,
    staff: [],
    sname: null,
    reasons: null,
    truck_type: null,
    truck_reason: null,
    department: null,

    ticket: [],
    // reasons:null,

    code: null,
    msg: null,
    history: [],
    access: [],
    record: [],
    region: {
      regular: [],
      unregular: []
    },
    corp_ticket: [],
    recordInfo: [],
    visitor_type: [],
    leader_lst: [], //审批人列表
    // ====================================================
    // 后台
    //=====================================================
    user: null,
    // staff: [],
    getRegion: null,
    getInvite: null,
    getInvite_total: 0,

    record_reserve: null,
    record_reserve_total: 0,

    getArrive: null,
    getArrive_total: 0,
    system: null,
    getPort: [],
    item_type: null, // 物品类型
    release_reason: null, // 放行原因
    release_record: null, // 放行条记录列表
    release_record_detail: null, // 放行条记录详细信息
    release_leader_lst: null, // 放行条审批人列表
    corp_lst: null, // 企业列表

    photo_url: null,

    idcard_information: null,
    timu: [],
    scores: []
  },
  mutations: {
    SET_IDCARD_INFORMATION: (state, item) => {
      state.idcard_information = item.data;
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_SCORES: (state, item) => {
      state.scores = item;
    },
    SET_TIMU: (state, item) => {
      state.timu = item;
    },
    SET_DATA: (state, item) => {
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_HISTORY: (state, item) => {
      state.history = item;
    },
    SET_ACCESS: (state, item) => {
      state.access = item;
    },
    SET_REGION: (state, item) => {
      state.region = item;
    },
    SET_RECORD: (state, item) => {
      state.record = item;
    },
    SET_TICKET: (state, item) => {
      state.ticket = item;
    },
    SET_CORP_TICKET: (state, item) => {
      state.corp_ticket = item;
    },
    SET_LANGUAGE: (state, item) => {
      state.language = item;
      // state.language = '3232';
      // console.log(item);
      // console.log(state.language);
      // console.log(state);
    },
    SET_RECORD_INFO: (state, item) => {
      state.recordInfo = item;
    },
    SET_VISITOR_TYPE: (state, item) => {
      state.visitor_type = item;
    },
    SET_VISITOR_INFO: (state, item) => {
      state.visitor = item.data;
      state.code = item.code;
      state.msg = item.msg;
      console.log(item);
    },
    SET_STAFF_NAME: (state, item) => {
      state.code = item.code;
      state.sname = item.data.name;
    },
    SET_STAFF_INFO: (state, item) => {
      state.staff = item.data;
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_SMS_CODE: (state, item) => {
      state.sms_code = item.data.sms_code;
      state.code = item.code;
      state.msg = item.msg;
    },
    SET_LEADER_LST: (state, item) => {
      state.leader_lst = item.data.leader_lst;
      // console.log(item);
      state.code = item.code;
      state.msg = item.msg;
    },
    // SET_REASONS: (state, item) => {
    //     state.reasons = item;
    // },
    // =====================================================
    // 后台
    // =====================================================
    SET_USER: (state, item) => {
      state.user = item;
    },
    SET_STAFF: (state, item) => {
      // 设置被访人信息
      state.staff = item;
    },
    SET_DEPARTMENT: (state, item) => {
      //设置部门信息
      state.department = item;
    },
    SET_REASONS: (state, item) => {
      //设置来访事由
      state.code = 0;
      state.reasons = item;
    },

    SET_TRUCK_TYPE: (state, item) => {
      //
      state.code = 0;
      state.truck_type = item;
    },

    SET_TRUCK_REASON: (state, item) => {
      //
      state.code = 0;
      state.truck_reason = item;
    },

    SET_RECORD_RESERVE: (state, item) => {
      state.record_reserve = item.record;
      state.record_reserve_total = item.total;
    },
    SET_GET_REGION: (state, item) => {
      state.getRegion = item;
    },
    SET_GET_INVITE: (state, item) => {
      state.getInvite = item.record;
      state.getInvite_total = item.total;
    },
    SET_GET_ARRIVE: (state, item) => {
      state.getArrive = item.record;
      state.getArrive_total = item.total;
    },
    SET_SYSTEM: (state, item) => {
      state.system = item;
    },
    SET_GET_PORT: (state, item) => {
      state.getPort = item;
    },

    SET_ITEM_TYPE: (state, item) => {
      state.item_type = item;
    },
    SET_RELEASE_REASON: (state, item) => {
      state.release_reason = item;
    },
    SET_RELEASE_RECORD: (state, item) => {
      state.release_record = item;
    },
    SET_RELEASE_RECORD_DETAIL: (state, item) => {
      state.msg = item.msg;
      state.code = item.code;
      state.release_record_detail = item.data;
    },
    SET_RELEASE_LEADER_LST: (state, item) => {
      state.release_leader_lst = item.data.leader_lst;
    },
    SET_CORP_LST: (state, item) => {
      state.corp_lst = item;
    },
    SET_IMAGE: (state, item) => {
      state.msg = item.msg;
      state.code = item.code;
      state.photo_url = item.data.photo_url;
      // console.log(1231);
      // console.log(state.photo_url);
    }
  },
  actions: {
    async getCorpLst({ commit }, content) {
      //获取企业列表

      const { data } = await http.getCorpLst(content);
      // console.log(data);
      commit("SET_CORP_LST", data.data);
    },

    async lang({ commit }, content) {
      //获取语言信息
      // async lang({commit}) {//获取语言信息
      const { data } = await http.lang(content);
      // console.log(data);
      // commit('SET_LANGUAGE', data.data);
      commit("SET_LANGUAGE", data);
    },
    async history({ commit }) {
      //邀请记录
      const { data } = await http.history();
      if (data.code === 0) {
        commit("SET_HISTORY", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async thistory({ commit }) {
      //
      const { data } = await http.thistory();
      if (data.code === 0) {
        commit("SET_HISTORY", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async region({ commit }) {
      const { data } = await http.region();
      if (data.code === 0) {
        commit("SET_REGION", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async record({ commit }) {
      const { data } = await http.record();
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async approval({commit}, content) {
    //     const {data} = await http.approval(content.id, content.status, content.cause);
    //     commit('SET_DATA', data);

    // },
    // async num({commit}, content) {
    //     const {data} = await http.num(content.id, content.num);
    //     commit('SET_DATA', data);
    // },
    async invite({ commit }, content) {
      const { data } = await http.invite(content);
      commit("SET_DATA", data);
    },
    async vpersonal({ commit }, content) {
      //提交访客个人信息
      const { data } = await http.vpersonal(content);
      commit("SET_DATA", data);
    },
    async getVRecord({ commit }, content) {
      //访客获取模板消息记录
      const { data } = await http.getVRecord(content);
      commit("SET_DATA", data);
    },
    async getUserInfo({ commit }) {
      //获取访客个人信息
      const { data } = await http.getUserInfo();
      commit("SET_VISITOR_INFO", data);
    },

    async tpersonal({ commit }, content) {
      //
      const { data } = await http.tpersonal(content);
      commit("SET_DATA", data);
    },

    async getVisitorInfo({ commit }) {
      //获取访客个人信息
      const { data } = await http.getVisitorInfo();
      commit("SET_VISITOR_INFO", data);
    },
    async getStaffName({ commit }, content) {
      //获取被访人姓名
      const { data } = await http.getStaffName(content);
      commit("SET_STAFF_NAME", data);
      // console.log(data.data);
    },
    async staffRefuse({ commit }, content) {
      //被访人员拒绝预约来访
      const { data } = await http.staffRefuse(content);
      commit("SET_DATA", data);
    },
    async staffAgree({ commit }, content) {
      //被访人员同意预约来访
      const { data } = await http.staffAgree(content);
      commit("SET_DATA", data);
    },

    async staffTRefuse({ commit }, content) {
      //
      const { data } = await http.staffTRefuse(content);
      commit("SET_DATA", data);
    },
    async staffTAgree({ commit }, content) {
      //
      const { data } = await http.staffTAgree(content);
      commit("SET_DATA", data);
    },

    async leaderRefuse({ commit }, content) {
      //领导拒绝预约来访
      const { data } = await http.leaderRefuse(content);
      commit("SET_DATA", data);
    },
    async leaderAgree({ commit }, content) {
      //领导同意预约来访
      const { data } = await http.leaderAgree(content);
      commit("SET_DATA", data);
    },
    async leaderAgreeAll({ commit }, content) {
      //领导同意预约来访
      const { data } = await http.leaderAgreeAll(content);
      commit("SET_DATA", data);
    },
    async getStaffRecord({ commit }, content) {
      //获取员工的预约、邀请记录
      const { data } = await http.getStaffRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVisitorRecord({ commit }) {
      //获取访客预约记录
      const { data } = await http.getVisitorRecord();
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async getReasons({commit}, content){//获取来访事由
    //     const {data} = await http.getReasons(content);
    //     commit('SET_REASONS', data);
    //     console.log(data);
    //     console.log(123);
    // },
    async vreserve({ commit }, content) {
      //访客发起预约
      const { data } = await http.vreserve(content);
      commit("SET_DATA", data);
    },

    async treserve({ commit }, content) {
      //
      const { data } = await http.treserve(content);
      commit("SET_DATA", data);
    },

    async tinvite({ commit }, content) {
      //
      const { data } = await http.tinvite(content);
      commit("SET_DATA", data);
    },

    async getStaffInfo({ commit }) {
      //获取被访人个人信息
      const { data } = await http.getStaffInfo();
      commit("SET_STAFF_INFO", data);
      // console.log(data);
    },
    async spersonal({ commit }, content) {
      //被访人员绑定身份
      const { data } = await http.spersonal(content);
      commit("SET_DATA", data);
    },
    async disSpersonal({ commit }, content) {
      //解除绑定
      const { data } = await http.disSpersonal(content);
      commit("SET_DATA", data);
    },
    async getCode({ commit }, content) {
      //获取验证码
      const { data } = await http.getCode(content);
      commit("SET_SMS_CODE", data);
    },
    async getSRecord({ commit }, content) {
      //被访人员获取模板消息记录
      const { data } = await http.getSRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getSTRecord({ commit }, content) {
      //被访人员获取模板消息记录
      const { data } = await http.getSTRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getSTRecord({ commit }, content) {
      //
      const { data } = await http.getSTRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getLRecord({ commit }, content) {
      //部门领导获取模板消息记录
      const { data } = await http.getLRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVRecord({ commit }, content) {
      //访客获取模板消息记录
      const { data } = await http.getVRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getCRecord({ commit }, content) {
      //抄送人获取模板消息记录
      const { data } = await http.getCRecord(content);
      if (data.code === 0) {
        commit("SET_RECORD", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getTicket({ commit }, content) {
      const { data } = await http.getTicket(content);
      if (data.code === 0) {
        commit("SET_TICKET", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getCorpTicket({ commit }, content) {
      const { data } = await http.getCorpTicket(content);
      if (data.code === 0) {
        commit("SET_CORP_TICKET", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async searchLeaderLst({ commit }, content) {
      //获取审批人列表
      const { data } = await http.searchLeaderLst(content);
      if (data.code === 0) {
        commit("SET_LEADER_LST", data);
        // console.log(data.data.leader_lst);
      } else {
        commit("SET_DATA", data);
      }
    },

    // async access({commit}, content) {
    //     const {data} = await http.access();
    //     if (data.code === 0) {
    //         commit('SET_ACCESS', data.data);
    //     } else {
    //         commit('SET_DATA', data)
    //     }
    // },
    // async getRecord({commit}, content) {
    //     const {data} = await http.getRecord(content);
    //     if (data.code === 0) {
    //         commit('SET_RECORD_INFO', data.data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    // ======================================================
    // 后台
    // ======================================================
    async signIn({ commit }, content) {
      //登陆后台
      const { data } = await http.signIn(content);
      // console.log(data.data);
      if (data.code === 0) {
        commit("SET_USER", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async staff({ commit }) {
      //获取员工数据
      const { data } = await http.staff();
      if (data.code === 0) {
        commit("SET_STAFF", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createStaff({ commit }, content) {
      //单个添加员工信息
      const { data } = await http.createStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteStaff({ commit }, content) {
      //单个删除员工信息
      const { data } = await http.deleteStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateStaff({ commit }, content) {
      //单个修改员工信息
      const { data } = await http.updateStaff(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async searchStaff({ commit }, content) {
      //查找指定员工数据
      const { data } = await http.searchStaff(content);
      if (data.code === 0) {
        commit("SET_STAFF", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getDepartment({ commit }, content) {
      //获取部门数据
      const { data } = await http.getDepartment(content);
      if (data.code === 0) {
        commit("SET_DEPARTMENT", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createDepartment({ commit }, content) {
      //单个添加部门信息
      const { data } = await http.createDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteDepartment({ commit }, content) {
      //单个删除部门信息
      const { data } = await http.deleteDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateDepartment({ commit }, content) {
      //单个修改部门信息
      const { data } = await http.updateDepartment(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getReasons({ commit }) {
      //获取来访事由
      const { data } = await http.getReasons();
      console.log(data);
      if (data.code === 0) {
        commit("SET_REASONS", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getTruckType({ commit }) {
      //
      const { data } = await http.getTruckType();
      console.log(data);
      if (data.code === 0) {
        commit("SET_TRUCK_TYPE", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getTruckReason({ commit }) {
      //
      const { data } = await http.getTruckReason();
      console.log(data);
      if (data.code === 0) {
        commit("SET_TRUCK_REASON", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getVisitorType({ commit }) {
      //获取来访类型
      const { data } = await http.getVisitorType();
      console.log(data);
      if (data.code === 0) {
        commit("SET_VISITOR_TYPE", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async createReasons({ commit }, content) {
      //单个添加来访事由
      const { data } = await http.createReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async deleteReasons({ commit }, content) {
      //单个删除来访事由
      const { data } = await http.deleteReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async updateReasons({ commit }, content) {
      //单个修改来访事由
      const { data } = await http.updateReasons(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async searchReserve({ commit }, content) {
      const { data } = await http.searchReserve(content);
      if (data.code === 0) {
        commit("SET_RECORD_RESERVE", data.data);
        console.log(data.data);
      } else {
        commit("SET_DATA", data.data);
      }
    },
    async deleteRecord({ commit }, content) {
      //单个预约记录
      const { data } = await http.deleteRecord(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getRegion({ commit }) {
      //获取门禁配置
      const { data } = await http.getRegion();
      if (data.code === 0) {
        commit("SET_GET_REGION", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async getInvite({commit}, content) {
    //     const {data} = await http.getInvite(content);
    //     if (data.code === 0) {
    //         commit('SET_GET_INVITE', data.data);
    //     } else {
    //         commit('SET_DATA', data);
    //     }
    // },
    async getArrive({ commit }, content) {
      //获取访客到访记录
      const { data } = await http.getArrive(content);
      if (data.code === 0) {
        commit("SET_GET_ARRIVE", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async staffData({commit}) {
    //     const {data} = await http.staffData();
    //     commit('SET_DATA', data);
    // },
    // async menuData({commit}) {
    //     const {data} = await http.menuData();
    //     commit('SET_DATA', data);
    // },
    // async changePassword({commit}, content) {
    //     const {data} = await http.changePassword(content);
    //     commit('SET_DATA', data);
    // },

    async getSystem({ commit }) {
      //获取邀请记录
      const { data } = await http.getSystem();
      commit("SET_SYSTEM", data.data);
    },
    async changeSystem({ commit }, content) {
      //修改配置信息
      const { data } = await http.changeSystem(content);
      commit("SET_DATA", data);
    },
    async deleteRegion({ commit }, content) {
      const { data } = await http.deleteRegion(content);
      commit("SET_DATA", data);
    },
    async getPort({ commit }) {
      const { data } = await http.getPort();
      if (data.code === 0) {
        commit("SET_GET_PORT", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },
    // async createRegion({commit}, content) {
    //     const {data} = await http.createRegion(content);
    //     commit('SET_DATA', data);
    // },
    // async updateRegion({commit}, content) {
    //     const {data} = await http.updateRegion(content);
    //     commit('SET_DATA', data);
    // },
    async searchInvite({ commit }, content) {
      const { data } = await http.searchInvite(content);
      if (data.code === 0) {
        commit("SET_GET_INVITE", data.data);
      } else {
        commit("SET_DATA", data);
      }
    },

    // *************
    // 放行条
    async getItemType({ commit }) {
      //获取物品类型
      const { data } = await http.getItemType();
      commit("SET_ITEM_TYPE", data.data);
    },
    async getReleaseReason({ commit }) {
      //获取放行原因
      const { data } = await http.getReleaseReason();
      commit("SET_RELEASE_REASON", data.data);
    },
    async createRelease({ commit }, content) {
      //获取发起请假申请
      const { data } = await http.createRelease(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getReleaseRecord({ commit }, content) {
      //获取放行条记录列表
      const { data } = await http.getReleaseRecord(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getReleaseRecordLeader({ commit }, content) {
      //
      const { data } = await http.getReleaseRecordLeader(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getReleaseRecordReturn({ commit }, content) {
      //
      const { data } = await http.getReleaseRecordReturn(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getReleaseRecordDetail({ commit }, content) {
      //获取放行条记录列表
      console.log(commit);
      const { data } = await http.getReleaseRecordDetail(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async leaderAgreeRelease({ commit }, content) {
      //二级审批同意放行条申请
      // console.log(commit);
      const { data } = await http.leaderAgreeRelease(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async leaderRefuseRelease({ commit }, content) {
      //二级审批同意放行条申请
      // console.log(commit);
      const { data } = await http.leaderRefuseRelease(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async searchReleaseLeaderLst({ commit }, content) {
      //获取放行条审批人列表
      const { data } = await http.searchReleaseLeaderLst(content);
      if (data.code === 0) {
        commit("SET_RELEASE_LEADER_LST", data);
        // console.log(data.data.leader_lst);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getReleaseRecordToday({ commit }, content) {
      //获取放行条记录列表-当天
      const { data } = await http.getReleaseRecordToday(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getReleaseRecordDetailToday({ commit }, content) {
      //获取放行条记录列表-当天
      console.log(commit);
      const { data } = await http.getReleaseRecordDetailToday(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async getTruckRecord({ commit }, content) {
      //-当天
      const { data } = await http.getTruckRecord(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getTruckRecordToday({ commit }, content) {
      //-当天
      const { data } = await http.getTruckRecordToday(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getTruckRecordDetailToday({ commit }, content) {
      //-当天
      console.log(commit);
      const { data } = await http.getTruckRecordDetailToday(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async securityAgreeReturn({ commit }, content) {
      //保安确认物品返回
      const { data } = await http.securityAgreeReturn(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async securityRefuseRelease({ commit }, content) {
      //保安拒绝放行
      const { data } = await http.securityRefuseRelease(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async securityAgreeRelease({ commit }, content) {
      //保安确认放行
      const { data } = await http.securityAgreeRelease(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async securityRefuseTruck({ commit }, content) {
      //
      const { data } = await http.securityRefuseTruck(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async securityAgreeTruck({ commit }, content) {
      //
      const { data } = await http.securityAgreeTruck(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async addBuChong({ commit }, content) {
      //
      const { data } = await http.addBuChong(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },

    async uploadImages(
      {
        // 把微信公众号的临时照片存储到本地，并反馈照片是人脸是人脸照片是否符合初期的入库标准
        commit
      },
      content
    ) {
      const { data } = await http.uploadImages(content);
      commit("SET_IMAGE", data);
    },

    async getScores({ commit }, content) {
      //获取考试分数
      const { data } = await http.getScores(content);
      if (data.code === 0) {
        commit("SET_SCORES", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },
    async getKaoShi({ commit }, content) {
      //获取考试题目
      const { data } = await http.getKaoShi(content);
      if (data.code === 0) {
        commit("SET_TIMU", data.data);
        console.log(data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async submitdati({ commit }, content) {
      //
      const { data } = await http.submitdati(content);
      if (data.code === 0) {
        commit("SET_DATA", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getIdCardInfomation({ commit }, content) {
      //
      const { data } = await http.getIdCardInfomation(content);
      if (data.code === 0) {
        // commit("SET_DATA", data);
        commit("SET_IDCARD_INFORMATION", data);
      } else {
        commit("SET_DATA", data);
      }
    },

    async getReleaseRecordStaffReturn({ commit }, content) {
      //员工查看自己还有哪些物品没有返回
      const { data } = await http.getReleaseRecordStaffReturn(content);
      commit("SET_RELEASE_RECORD", data.data);
    },
    async getReleaseRecordDetailStaffReturn({ commit }, content) {
      //员工查看物品返回记录详情
      console.log(commit);
      const { data } = await http.getReleaseRecordDetailStaffReturn(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async staffAgreeReturn({ commit }, content) {
      //员工最终确定物品返回
      const { data } = await http.staffAgreeReturn(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async changeReturnTime({ commit }, content) {
      //修改物品返回时间
      const { data } = await http.changeReturnTime(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async leaderAgreeReturnTime({ commit }, content) {
      //同意修改返回时间
      // console.log(commit);
      const { data } = await http.leaderAgreeReturnTime(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    },
    async leaderRefuseReturnTime({ commit }, content) {
      //拒绝修改返回时间

      const { data } = await http.leaderRefuseReturnTime(content);
      commit("SET_RELEASE_RECORD_DETAIL", data);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js